import { FC } from 'react';
import { Text, View } from '@react-pdf/renderer';

import Table from '../PdfTable';
import styles from './styles';

interface LostTaxReliefsProps {
  taxYear: string;
  lostTaxReliefs: Array<{
    name: string;
    investmentDate: string;
    investmentType: string;
    uir: string;
    formattedCapitalAllocated: string;
    formattedTaxRelief: string;
  }>;
  totals: {
    capitalAllocated: string;
    taxRelief: string;
  };
}

const LostTaxReliefs: FC<LostTaxReliefsProps> = ({
  taxYear,
  lostTaxReliefs,
  totals,
}) => {
  if (!lostTaxReliefs.length) {
    return (
      <View wrap={false}>
        <Text style={styles.heading}>Lost tax relief</Text>
        <Text style={styles.paragraph}>
          None of your investments lost its S/EIS tax relief status during the{' '}
          {taxYear} tax year.
        </Text>
      </View>
    );
  }

  return (
    <>
      <View wrap={false}>
        <Text style={styles.heading}>Lost tax relief</Text>
        <Text style={styles.paragraph}>
          The following investments lost their S/EIS tax relief status during
          this tax year:
        </Text>
      </View>

      <Table
        title={null}
        backgroundColor="white"
        fontColor="#333333"
        alignContent="left"
        fontSize={8}
        fullBorder
        expandRows
        columns={{
          investment: { value: 'Investment', bold: true },
          investmentDate: {
            value: 'Investment date',
            bold: true,
            width: 16,
          },
          reliefType: { value: 'Relief type', bold: true, width: 12 },
          uir: { value: 'UIR', bold: true, width: 13 },
          valueOfShares: {
            value: 'Investment value',
            bold: true,
            width: 20,
          },
          taxRelief: {
            value: 'Potential lost tax relief',
            bold: true,
            width: 20,
          },
        }}
        data={[
          ...lostTaxReliefs.map((taxRelief) => ({
            investment: {
              value: taxRelief.name,
            },
            investmentDate: {
              value: taxRelief.investmentDate,
              width: 16,
            },
            reliefType: {
              value: taxRelief.investmentType,
              width: 12,
            },
            uir: { value: taxRelief.uir, width: 13 },
            valueOfShares: {
              value: taxRelief.formattedCapitalAllocated,
              width: 20,
            },
            taxRelief: {
              value: taxRelief.formattedTaxRelief,
              width: 20,
            },
          })),
        ]}
        footer={{
          investment: {
            value: '',
          },
          investmentDate: {
            value: '',
            width: 16,
          },
          reliefType: {
            value: '',
            width: 12,
          },
          uir: { value: 'Total', bold: true, width: 13 },
          valueOfShares: {
            value: totals.capitalAllocated,
            bold: true,
            width: 20,
          },
          taxRelief: {
            value: totals.taxRelief,
            bold: true,
            width: 20,
          },
        }}
      />
      <Text style={[styles.paragraph, styles.topMargin]}>
        If you claimed UK income tax relief on the above investment(s), any
        claimed income tax relief must be repaid to HMRC. Please seek
        professional tax advice or contact HMRC for further instructions.
      </Text>
      <Text style={styles.paragraph}>
        If you have not yet claimed income tax relief on the above
        investment(s), you may no longer do so.
      </Text>
    </>
  );
};

export default LostTaxReliefs;
